// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"9c4a78dd","453":"0121ea0e"}[chunkId] + ".chunk.js";
};